<template>
  <div class="content">
    <div class="page-inner">
      <div class="page-header">
        <h4 class="page-title">{{ $t('modify_metadata') }}</h4>
        <ul class="breadcrumbs">
          <li class="nav-home">
            <router-link to="/dashboard">
              <i class="flaticon-home"></i>
            </router-link>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <router-link to="/distributions">{{ $t('section_distribution') }}</router-link>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <a href="javascript:void(0)" v-if="distribution.title">{{ distribution.title }}</a>
          </li>
        </ul>
      </div>
      <div class="row metadata">
        <div class="col-md-12">
          <div class="card card-space pt-3 pb-3">
            <div class="card-title" v-if="distribution.title">
              {{ distribution.title }}
              <div class="float-right">
                <span class="mr-3 text-16">{{ $t('metadata_request_per_month') }}: {{ metadataRequesPerMonthLimit }} / 5</span>
                <button type="button" class="btn btn-primary " @click="saveMetadata()" :disabled="saving || !enableSave">
                  {{ $t('sent_request') }}
                  <span v-if="saving">
                    <i class="fa fa-spinner fa-spin"></i>
                  </span>
                </button>
              </div>
            </div>
            <div class="title">
              <br/>
              <span class="text-4 float-right">{{ $t('change_release_revision') }}</span>
            </div>
          </div>
          <div class="options" v-if="validDistro">
            <div class="card-body bg-2 container-service" v-if="activeService._id">
              <fieldset>
                <legend class="text-14">
                  <span class="title">{{ $t('selected_service_details') }}</span>
                </legend>
                <div class="row mb-4">
                  <div class="col-md-12">
                    <div class="separator-solid"></div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{ $t('name') }}</label>
                      <div>{{ activeService.service_type.name }}</div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{ $t('payment_date') }}</label>
                      <div>{{ moment(activeService.paidAt).format('LLL') }}</div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="separator-solid"></div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="card distribution-section">
              <div class="card-header w-100 collapsed" data-toggle="collapse" href="#accord_release_information" role="button">
                <span>{{ $t('release_information') }}</span> <span class="has-changes" v-html="metadataRequestState.DistributionEditor"></span>
              </div>
              <div class="card-content collapse" id="accord_release_information">
                <DistributionEditor :fromMetadataPage="true"></DistributionEditor>
              </div>
            </div>
            <div class="card distribution-section">
              <div class="card-header w-100 collapsed" data-toggle="collapse" href="#accord_track_information" role="button">
                <span>{{ $t('track_information') }}</span> <span class="has-changes" v-html="metadataRequestState.DistributionSongs"></span>
              </div>
              <div class="card-content collapse" id="accord_track_information">
                <DistributionSongs :fromMetadataPage="true"></DistributionSongs>
              </div>
            </div>
            <div class="card distribution-section">
              <div class="card-header w-100 collapsed" data-toggle="collapse" href="#accord_cover_art" role="button">
                <span>{{ $t('cover_art') }}</span> <span class="has-changes" v-html="metadataRequestState.DistributionCover"></span>
              </div>
              <div class="card-content collapse" id="accord_cover_art">
                <DistributionCover :fromMetadataPage="true"></DistributionCover>
              </div>
            </div>
            <div class="card distribution-section">
              <div class="card-header w-100 collapsed" data-toggle="collapse" href="#accord_store_selection" role="button">
                <span>{{ $t('store_selection') }}</span> <span class="has-changes" v-html="metadataRequestState.DistributionStores"></span>
              </div>
              <div class="card-content collapse" id="accord_store_selection">
                <DistributionStores :fromMetadataPage="true"></DistributionStores>
              </div>
            </div>
            <div class="card distribution-section">
              <div class="card-header w-100 collapsed" data-toggle="collapse" href="#accord_final_review" role="button">
                <span>{{ $t('final_review') }}</span> <span class="has-changes" v-html="metadataRequestState.DistributionReview"></span>
              </div>
              <div class="card-content collapse" id="accord_final_review">
                <DistributionReview :fromMetadataPage="true"></DistributionReview>
              </div>
            </div>
          </div>
          <div class="text-center text-40" v-else>
            <i class="fa fa-spinner fa-spin"></i>
          </div>
          <div class="card card-space pt-3 pb-3">
            <div class="title">
              <button type="button" class="btn btn-primary float-right" @click="saveMetadata()" :disabled="saving || !enableSave">
                {{ $t('sent_request') }}
                <span v-if="saving">
                  <i class="fa fa-spinner fa-spin"></i>
                </span>
              </button>
            </div>
            <div class="title">
              <br/>
              <span class="text-4 float-right">{{ $t('change_release_revision') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div ref="resumeModal" class="modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="text-center mb-4">
              <h1>Metadata Request Changes</h1>
            </div>
            <div class="mb-3">
              <div v-if="
                distribution.metadata_request_data &&
                distribution.metadata_request_data['DistributionEditor'] &&
                Object.keys(distribution.metadata_request_data['DistributionEditor']).length
              ">
                <span>{{ $t('release_information') }}</span>
                <ul>
                  <li v-for="(item, key) in distribution.metadata_request_data['DistributionEditor']" v-bind:key="`distro_${key}`">
                    {{ key }}<br>
                    old -> {{ distribution[key] }}<br>
                    new -> {{ item }}
                  </li>
                </ul>
              </div>
              <div v-if="
                distribution.metadata_request_data &&
                distribution.metadata_request_data['DistributionSongs'] &&
                Object.keys(distribution.metadata_request_data['DistributionSongs']).length
              ">
                <span>{{ $t('track_information') }}</span>
                <ul>
                  <li v-for="(song, key) in distribution.metadata_request_data['DistributionSongs'].songs" v-bind:key="`distro_${key}`">
                    <div v-if="Object.keys(song).length > 0">
                      Song {{ key }}<br>
                      <div v-for="(item, key2) in song" v-bind:key="`song_${key2}`">
                        {{ key2 }}<br>
                        old -> {{ distribution.songs[key][key2] }}<br>
                        new -> {{ item }}
                      </div>
                    </div>
                    <div v-else>
                      Song {{ key }} no changes
                    </div>
                  </li>
                </ul>
              </div>
              <div v-if="
                distribution.metadata_request_data &&
                distribution.metadata_request_data['DistributionCover'] &&
                Object.keys(distribution.metadata_request_data['DistributionCover']).length
              ">
                <span>{{ $t('cover_art') }}</span>
                <ul>
                  <li v-for="(item, key) in distribution.metadata_request_data['DistributionCover']" v-bind:key="`distro_${key}`">
                    {{ key }}<br>
                    old -> {{ distribution[key] }}<br>
                    new -> {{ item }}
                  </li>
                </ul>
              </div>
              <div v-if="
                distribution.metadata_request_data &&
                distribution.metadata_request_data['DistributionStores'] &&
                Object.keys(distribution.metadata_request_data['DistributionStores']).length
              ">
                <span>{{ $t('store_selection') }}</span>
                <ul>
                  <li v-for="(item, key) in distribution.metadata_request_data['DistributionStores']" v-bind:key="`distro_${key}`">
                    <div v-if="!(typeof item === 'object')">
                      {{ key }}<br>
                      old -> {{ distribution[key] }}<br>
                      new -> {{ item }}
                    </div>
                    <div v-else>
                      {{ key }}<br>
                      old -> {{ distribution[key] }}
                      <br> <hr>
                      new -> {{ item }}
                    </div>
                  </li>
                </ul>
              </div>
              <div v-if="
                distribution.metadata_request_data &&
                distribution.metadata_request_data['DistributionReview'] &&
                Object.keys(distribution.metadata_request_data['DistributionReview']).length
              ">
                <span>{{ $t('final_review') }}</span>
                <ul>
                  <li v-for="(item, key) in distribution.metadata_request_data['DistributionReview']" v-bind:key="`distro_${key}`">
                    {{ key }}<br>
                    old -> {{ distribution[key] }}<br>
                    new -> {{ item }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-dark" data-dismiss="modal">{{ $t('close') }}</button>
            <button type="button" class="btn btn-success" data-dismiss="modal" @click="saveMetadata()">
              {{ $t('continue') }}
            </button>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import _ from 'underscore'
import moment from 'moment'
import DistributionEditor from '../components/DistributionEditor'
import DistributionSongs from '../components/DistributionSongs'
import DistributionCover from '../components/DistributionCover'
import DistributionStores from '../components/DistributionStores'
import DistributionReview from '../components/DistributionReview'
import Distributions from '../services/distributions'
import ServicesOnDemand from '../services/services-on-demand'

export default {
  name: 'DistributionMetadata',
  data: function () {
    return {
      distribution: {
        _id: null,
        title: null,
        status: null,
        metadata_request_data: {}
      },
      valid_status: [2, 3],
      metadataRequestState: {
        DistributionEditor: '',
        DistributionSongs: '',
        DistributionCover: '',
        DistributionStores: '',
        DistributionReview: ''
      },
      saving: false,
      enableSave: false,
      metadataRequesPerMonthLimit: 0,
      activeService: {
        _id: '',
        total: 0,
        payment_method: '',
        service_type: {},
        paidAt: ''
      },
      moment: moment
    }
  },
  computed: {
    validDistro: function () {
      return _.contains(this.valid_status, this.distribution.status)
    }
  },
  methods: {
    hasMetadataRequest: function () {
      let isEmpty = false
      _.each(this.distribution.metadata_request_data, (page, key) => {
        if (!_.contains(['old', 'new'], key)) {
          _.each(page, (data, key2) => {
            switch (typeof data) {
              case 'number':
              case 'string':
                if (String(data) !== '') {
                  isEmpty = true
                }
                break
              case 'object':
                _.each(data, el => {
                  if (Object.keys(el).length) {
                    isEmpty = true
                  }
                })
                break
            }
          })
        }
      })
      return isEmpty
    },
    updateChanges: function (metadataChange) {
      let emptyElem = false
      _.each(metadataChange.data, elem => {
        if (Object.keys(elem).length) {
          emptyElem = true
        }
      })
      if (emptyElem) {
        this.metadataRequestState[metadataChange.origin] = '<i><b>Changes unsaved</b></i>'
      } else {
        this.metadataRequestState[metadataChange.origin] = ''
      }
    },
    saveMetadata: function () {
      if (this.metadataRequesPerMonthLimit < 5) {
        window.swal({
          title: this.$t('are_you_sure'),
          text: this.$t('metadata_confirm_description'),
          buttons: {
            cancel: {
              visible: true,
              text: this.$t('cancel'),
              className: 'btn btn-default btn-border no-border'
            },
            confirm: {
              text: this.$t('ok'),
              className: 'btn btn-primary'
            }
          }
        }).then(confirm => {
          if (!confirm) {
            return
          }
          this.saving = true
          Distributions.confirmMetadaRequest(this.distribution._id, this.activeService._id).then(response => {
            this.saving = false
            this.$router.push(`/distributions/${this.$route.params.id}/links`)
            this.$notify({ message: this.$t('metadata_changes_sent') }, 'success', 'fa-check')
          })
        })
      } else {
        return this.$notify({ message: this.$t('metadata_request_per_month_limit_reached') }, 'warning', 'fa-exclamation')
      }
    },
    initializeDistribution: function () {
      return Distributions.get(this.$route.params.id).then(response => {
        this.distribution = response.data
        if (!_.contains([2, 3], this.distribution.status) || this.distribution.f_state !== 'DELIVERED') {
          this.$router.push(`/distributions?missing_status=1`)
        }
        if (!(!this.distribution.modify_metadata || this.distribution.modify_metadata === 0)) {
          this.$router.push(`/distributions/${this.$route.params.id}/links`)
          this.$notify({ message: this.$t('metadata_changes_already_sent') }, 'success', 'fa-check')
        }

        this.$eventBus.$on('notifyMetadataChanges', metadataChange => {
          if (!this.distribution.metadata_request_data) {
            this.distribution.metadata_request_data = {}
          }
          if (!this.distribution.metadata_request_data[metadataChange.origin]) {
            this.distribution.metadata_request_data[metadataChange.origin] = {}
          }
          if (metadataChange.data) {
            let isEmpty = false
            _.each(Object.keys(metadataChange.data), elem => {
              switch (typeof metadataChange.data[elem]) {
                case 'number':
                case 'string':
                  if (metadataChange.data[elem]) {
                    isEmpty = true
                  }
                  break
                case 'object':
                  _.each(metadataChange.data[elem], el => {
                    if (Object.keys(el).length) {
                      isEmpty = true
                    }
                  })
                  break
              }
            })
            if (isEmpty) {
              this.metadataRequestState[metadataChange.origin] = '<i class="ml-2 fas fa-circle"></i>'
            } else {
              this.metadataRequestState[metadataChange.origin] = ''
            }
          }
        })

        this.$eventBus.$on('notifyMetadataModified', metadataChange => {
          this.distribution.metadata_request_data[metadataChange.origin] = metadataChange.data
          this.enableSave = this.hasMetadataRequest()
          this.metadataRequestState[metadataChange.origin] = '<i class="ml-2 fas fa-circle"></i>'
        })

        if (this.distribution.metadata_request_data) {
          this.enableSave = this.hasMetadataRequest()
          _.each(Object.keys(this.distribution.metadata_request_data), elem => {
            if (this.distribution.metadata_request_data[elem] && Object.keys(this.distribution.metadata_request_data[elem]).length > 0) {
              this.metadataRequestState[elem] = '<i class="ml-2 fas fa-circle"></i>'
            }
          })
        }

        Distributions.getResquestByMonth().then(response => {
          this.metadataRequesPerMonthLimit = response.data.requested
        })
      })
    },
    allowUserContinuePromise: function () {
      return new Promise((resolve, reject) => {
        if (this.$route.params.id) {
          if (this.user.subscription) {
            resolve()
          } else {
            ServicesOnDemand.getServicesBy('metadata_request').then(response => {
              if (response.data.length) {
                this.distribution.service = response.data[0]._id
                this.activeService = response.data[0]
                resolve()
              } else {
                reject(new Error('empty_service'))
              }
            })
          }
        } else {
          reject(new Error('empty_id'))
        }
      })
    }
  },
  created: function () {
    this.user = this.$user
    this.allowUserContinuePromise()
      .then(this.initializeDistribution)
      .catch(error => {
        let urlErr = '/distributions'

        if (error === 'empty_service') {
          urlErr = '/distributions?missing_service=1'
        } else if (error === 'empty_id') {
          urlErr = '/distributions?missing_id=1'
        }
        this.$router.push(urlErr)
      })
  },
  components: {
    DistributionEditor,
    DistributionSongs,
    DistributionCover,
    DistributionStores,
    DistributionReview
  },
  watch: {}
}
</script>
<style lang="scss" scoped>
  .metadata {
    .options {
      .distribution-section {
        margin-bottom: 15px;
        .card-header {
          cursor: pointer;
        }
      }
    }
    .has-changes {
      color: #5714ff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DistributionMetadata.vue